import React from 'react';
const Context = React.createContext(null);
export function createBlockContextProvider() {
    return {
        Provider: Context.Provider,
        useContext() {
            const context = React.useContext(Context);
            if (!context) {
                throw new Error('useBlockContext must be used within a BlockContextProvider');
            }
            return context;
        },
    };
}
//# sourceMappingURL=contextProvider.js.map